/* Viretta 5-Ply landing (sections/v2-landing-5ply.liquid): clips load and play only while on screen (one page-wide motion
   button pauses all of them; reduced motion = posters only), the surface switch on the range, the film loads on click,
   and the notify forms add the newsletter tag when that box is ticked. */
(function () {
  var root = document.querySelector('[data-v2-l5]');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var still = reduce;
  var clips = [].slice.call(root.querySelectorAll('[data-v2-clip]'));

  function start(c) {
    var v = c.querySelector('video'); if (!v || still) return;
    if (!v.src) { v.src = v.getAttribute('data-src'); }
    var p = v.play(); if (p && p.then) p.then(function () { c.classList.add('is-playing'); }).catch(function () {});
  }
  function stop(c) { var v = c.querySelector('video'); if (v && !v.paused) v.pause(); }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target._vis = e.isIntersecting; if (e.isIntersecting) start(e.target); else stop(e.target); });
  }, { rootMargin: '200px 0px' }) : null;
  clips.forEach(function (c) { if (io) io.observe(c); else start(c); });

  function setStill(s) {
    still = s;
    root.classList.toggle('is-still', s);
    clips.forEach(function (c) {
      var b = c.querySelector('[data-v2-motion]'); if (b) b.setAttribute('aria-label', s ? 'Videos abspielen' : 'Videos pausieren');
      if (s) stop(c); else if (c._vis || !io) start(c);
    });
  }
  if (reduce) setStill(true);

  root.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    if (b.hasAttribute('data-v2-motion')) { setStill(!still); return; }
    if (b.hasAttribute('data-v2-sfc')) {
      var sec = b.closest('[data-v2-surf]'); var ti = b.getAttribute('data-v2-sfc') === 'ti';
      sec.classList.toggle('is-ti', ti);
      sec.querySelectorAll('[data-v2-sfc]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      return;
    }
    if (b.hasAttribute('data-v2-filmplay')) {
      var box = b.closest('[data-v2-film]');
      var v = document.createElement('video');
      v.src = box.getAttribute('data-src'); v.controls = true; v.autoplay = true; v.playsInline = true; v.setAttribute('playsinline', '');
      v.poster = b.querySelector('img').src;
      box.replaceChildren(v);
      clips.forEach(stop);
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      v.focus();
    }
  });

  /* newsletter tick → add the tag */
  root.addEventListener('submit', function (e) {
    var f = e.target; var nl = f.querySelector('[data-v2-nl]'); var tags = f.querySelector('[data-v2-tags]');
    if (nl && tags) tags.value = nl.checked ? '5-ply-venteliste,newsletter' : '5-ply-venteliste';
  });

  document.addEventListener('visibilitychange', function () { if (document.hidden) clips.forEach(stop); else clips.forEach(function (c) { if (c._vis) start(c); }); });
})();
